/*
 * This file is a generated Typescript file for GRPC Gateway, DO NOT MODIFY
 */

import * as fm from "../../../fm"


/**
 * Сервис возможностей устройства
 */

/**
 * Сервис возможностей устройства
 */
export class CapabilityServiceClient {
  /**
   * Конструктор сервиса
   * @param host Адрес хоста
   * @param token Токен доступа
   */
  constructor(
    public host = "",
    public token = ""
  ) { }

  /**
   * Метод получения возможностей устройства
   */
  GetCapabilityList = (req?: GetCapabilityListRequestDto, init?: RequestInit): Promise<GetCapabilityListResponseDto> => {
    return fm.request<GetCapabilityListRequestDto, GetCapabilityListResponseDto>(`${this.host}/device/api/v1/capability/list${fm.buildQuery(req)}`, { ...init, method: "GET", ...{ headers: { ...init?.headers, ...{ 'Authorization': `Bearer ${this.token}` } } } })
  }

}

/**
 * Возможность устройства
 */
export type CapabilityRequestDto = {
}
/**
 * kind
 */
& fm.OptionalOneOf<{
  /**
   * Профиль шифрования
   */
  readonly encryptionProfile: CapabilityEncryptionProfileRequestDto
}>
/**
 * Возможность устройства
 */
export type CapabilityResponseDto = {
}
/**
 * kind
 */
& fm.OneOf<{
  /**
   * Профиль шифрования
   */
  readonly encryptionProfile: CapabilityEncryptionProfileResponseDto
}>
/**
 * Профиль шифрования
 */
export type CapabilityEncryptionProfileRequestDto = {
}
/**
 * Профиль шифрования
 */
export type CapabilityEncryptionProfileResponseDto = {
}
/**
 * Фильтр возможностей устройства
 */
export type CapabilityFilterRequestDto = {
}
/**
 * Фильтр возможностей устройства
 */
export type CapabilityFilterResponseDto = {
}
/**
 * Запрос получения возможностей устройства
 */
export type GetCapabilityListRequestDto = {
  /**
   * Фильтр возможностей устройства
   */
  filter?: CapabilityFilterRequestDto | null
}
/**
 * Ответ на запрос получения возможностей устройства
 */
export type GetCapabilityListResponseDto = {
  /**
   * Список Capability
   */
  data: CapabilityResponseDto[]
}
/**
 * Дескриптор
 */
export const descriptor = {
  /**
   * Возможность устройства
   */
  "Capability": {
    "kind": "class",
    "text": "Возможность устройства",
    "fields": {
      /**
       * Профиль шифрования
       */
      "encryptionProfile": {
        "type": "Capability.EncryptionProfile",
        "text": "Профиль шифрования",
      },
    },
  },
  /**
   * Профиль шифрования
   */
  "Capability.EncryptionProfile": {
    "kind": "class",
    "text": "Профиль шифрования",
  },
  /**
   * Фильтр возможностей устройства
   */
  "CapabilityFilter": {
    "kind": "class",
    "text": "Фильтр возможностей устройства",
  },
  /**
   * Запрос получения возможностей устройства
   */
  "GetCapabilityListRequest": {
    "kind": "class",
    "text": "Запрос получения возможностей устройства",
    "fields": {
      /**
       * Фильтр возможностей устройства
       */
      "filter": {
        "type": "CapabilityFilter",
        "text": "Фильтр возможностей устройства",
      },
    },
  },
  /**
   * Ответ на запрос получения возможностей устройства
   */
  "GetCapabilityListResponse": {
    "kind": "class",
    "text": "Ответ на запрос получения возможностей устройства",
    "fields": {
      /**
       * Список Capability
       */
      "data": {
        "type": "Capability",
        "text": "Список Capability",
      },
    },
  },
}